import React from 'react';

const cards = [
  { icon: require('../assets/img/we-are/icon-fast.png'), hex: require('../assets/img/we-are/hex-1.svg').default, title: 'Fast', subtitle: 'to Develop' },
  { icon: require('../assets/img/we-are/icon-efficient.png'), hex: require('../assets/img/we-are/hex-2.svg').default, title: 'Efficient', subtitle: 'Time to market' },
  { icon: require('../assets/img/we-are/icon-accurate.png'), hex: require('../assets/img/we-are/hex-3.svg').default, title: 'Accurate', subtitle: 'on First Time Delivery' },
  { icon: require('../assets/img/we-are/icon-complete.png'), hex: null, title: 'Complete', subtitle: 'Documentation' },
];

const WeAreSection: React.FC = () => {
  return (
    <section className="py-12 lg:py-20 bg-white">
      <div className="max-w-content mx-auto px-6">
        <h2 className="font-exo font-bold text-ebony-clay text-2xl lg:text-[38px] tracking-[1.9px] leading-normal text-center mb-12">
          We are
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {cards.map((card) => (
            <div key={card.title} className="relative flex flex-col items-center text-center">
              {card.hex && (
                <img
                  className="absolute -top-2 left-1/2 -translate-x-1/2 w-[74px] lg:w-[136px] h-auto -z-10"
                  src={card.hex}
                  alt=""
                />
              )}
              <img
                className="w-[88px] lg:w-[158px] h-[88px] lg:h-[158px]"
                src={card.icon}
                alt={card.title}
              />
              <div className="mt-8 lg:mt-[54px]">
                <div className="font-exo font-semibold text-eerie-black text-xl lg:text-[32px] tracking-[1.6px] leading-normal">
                  {card.title}
                </div>
                <div className="font-exo font-semibold text-eerie-black text-sm lg:text-base tracking-[0.8px] leading-normal">
                  {card.subtitle}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WeAreSection;
